__webpack_require__.p = "https://unpkg.com/qgridnext@2.0.4/dist/";